import { usePermissions } from '@/hooks/usePermissions'

import { Box, HStack, Spacer, Text } from '@chakra-ui/react'

import { LabeledSwitch } from '../../components/LabeledSwitch'

interface DryRunToggleIProps {
  isDryRun: boolean
  onDryRunToggle: () => void
  isLoading?: boolean
}

export const DryRunToggle = ({
  isDryRun,
  onDryRunToggle,
  isLoading = false,
}: DryRunToggleIProps) => {
  const { isImplementer } = usePermissions()

  if (!isImplementer) {
    return null
  }

  return (
    <Box>
      <HStack>
        <Box>
          <Text
            fontSize='16px'
            fontWeight='medium'
            letterSpacing='-0.8px'
            mb={2}
          >
            Enable Dry Run
          </Text>
          <Text color='gray.600' fontSize='sm' mb={4}>
            Run the AI Operator without acting on incidents to evaluate
            performance
          </Text>
        </Box>
        <Spacer />
        <Box>
          <LabeledSwitch
            id='dryRunToggle'
            isChecked={isDryRun}
            isDisabled={isLoading}
            onSwitchChange={onDryRunToggle}
          />
        </Box>
      </HStack>
    </Box>
  )
}
